import { BASE_PATH_API } from 'constants/env'
import { useState } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'

const useLinnkToBarcode = () =>{
    const Domain = BASE_PATH_API
    const [responseProduct, setResponseProducts] = useState(null)
    const [responseError, setResponseError] = useState(null)
    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    
    const getProduct = async (sku) => {
        dispatch(showLoader());
        setResponseProducts(null)
        setResponseError(null)
        try{
            const response = await fetch(`${Domain}/products/v1/products?filter_by[sku]=${sku}&filter_by[seller_id]=2430`);
            const data = await response.json();
            if(data?.data?.length >= 1){
                setResponseProducts(data?.data)
            }else{
                dispatch(hideLoader());
                setResponseError({
                    statusCode: data?.metadata?.http_status
                })
                dispatch(hideLoader());
            }
        } catch (error) {
            dispatch(hideLoader());
            console.error('Error fetching productsFilter data:', error);
        }
    }

    const handleSKU = (sku) => {
        getProduct(sku)
    }
    const setResetResponse = () => {
        setResponseProducts(null)
        setResponseError(null)
    }

    return {
        handleSKU,
        setResetResponse,
        responseProduct,
        responseError
    }
}

export default useLinnkToBarcode